/**
 * Legal & company information for Gate 33 — centralised.
 * NPDS is the operating legal entity registered in France.
 * These constants are used across the legal pages so any future update
 * (address, hosting provider, VAT rate) happens in a single place.
 */

export const COMPANY = {
  legalName: 'NPDS',
  tradingName: 'Gate 33',
  legalForm: 'Société (SARL/EURL — see Kbis)',
  siren: '534 221 387',
  siret: '534 221 387 000 28',
  vat: 'FR06 534 221 387',
  registrationCity: 'Paris',
  email: 'nicolas@gate33.co',
  website: 'https://gate33.co',
  publicationDirector: 'Nicolas Perot dos Santos',
  jurisdiction: 'French Courts (Paris)',
  governingLaw: 'French law',
};

export const HOSTING = {
  name: 'Emergent Labs Inc.',
  website: 'https://emergent.sh',
  address: '255 California Street, Suite 550, San Francisco, CA 94111, United States',
  phone: 'No public phone number — contact support@emergent.sh',
};


export const DPA_CONTACT = {
  role: 'Data Protection Contact (privacy@gate33.co)',
  email: 'nicolas@gate33.co',
  authority: 'CNIL — Commission Nationale de l\'Informatique et des Libertés',
  authorityWebsite: 'https://www.cnil.fr',
  authorityAddress: '3 Place de Fontenoy, TSA 80715, 75334 Paris Cedex 07',
};

export const PRODUCT = {
  name: '3-Day Online Training',
  price: '€600',
  priceInstallments: 'up to 24× payments with PayPal',
  format: 'Live online — three consecutive days',
  vatIncluded: true,
  description: 'Fourteen live modules over three consecutive days covering private aviation operations, catering, aircraft mastery and interview preparation. Delivered by Nicolas Perot dos Santos.',
};

export const LEGAL_UPDATED = '3 September 2026';
export const LEGAL_UPDATED_TERMS = '7 October 2026';

export const SELLER_ID = 'Nicolas Perot dos Santos, Entrepreneur Individuel (EI), trading as NPDS / Gate 33. RCS Paris 534 221 387 — SIRET 534 221 387 000 28 — Intracommunity VAT number FR06 534 221 387.';
